import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = "https://newalemny.3almny.app/api";

// Async thunk لجلب الاختبارات حسب المادة
export const fetchExamsBySubject = createAsyncThunk(
  "exams/fetchExamsBySubject",
  async ({ subjectId = 0, page = 1 } = {}, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      if (!token) {
        return rejectWithValue("لم يتم العثور على رمز المصادقة");
      }

      const response = await axios.get(
        `${BASE_URL}/tests/student_subject_tests/${subjectId}?page=${page}`,
        {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data;
      
      // Handle successful response
      let examsData = [];
      let paginationData = {};
      
      if (data.result && data.result.data) {
        examsData = data.result.data;
        paginationData = data.result.pagination || {};
      } else if (data.result) {
        examsData = data.result;
        paginationData = data.pagination || {};
      } else if (data.data) {
        examsData = data.data;
        paginationData = data.pagination || {};
      }
      
      // Normalize pagination data
      if (paginationData.last_page && !paginationData.pages_count) {
        paginationData.pages_count = paginationData.last_page;
      }
      if (paginationData.pages_count && !paginationData.last_page) {
        paginationData.last_page = paginationData.pages_count;
      }
      
      return {
        exams: Array.isArray(examsData) ? examsData : [],
        pagination: paginationData
      };
      
    } catch (error) {
      console.error('Error fetching exams:', error);
      
      // Handle axios errors
      if (error.response) {
        // Server responded with error status
        const errorMessage = error.response.data?.message || 
                           error.response.data?.error || 
                           `خطأ في الخادم: ${error.response.status}`;
        return rejectWithValue(errorMessage);
      } else if (error.request) {
        // Request was made but no response received
        return rejectWithValue("لا يمكن الاتصال بالخادم. يرجى التحقق من اتصال الإنترنت");
      } else {
        // Something else happened
        return rejectWithValue("حدث خطأ غير متوقع أثناء جلب الاختبارات");
      }
    }
  }
);

const initialState = {
  exams: [],
  loading: false,
  error: null,
  pagination: null,
  currentSubject: 0,
  currentPage: 1,
};

const examsSlice = createSlice({
  name: "exams",
  initialState,
  reducers: {
    setCurrentSubject: (state, action) => {
      state.currentSubject = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    clearExamsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExamsBySubject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExamsBySubject.fulfilled, (state, action) => {
        state.loading = false;
        state.exams = action.payload.exams;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchExamsBySubject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setCurrentSubject, setCurrentPage, clearExamsError } = examsSlice.actions;
export default examsSlice.reducer;